"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logError = void 0;
var env_1 = require("./env");
function logError(message) {
    if ((0, env_1.isProduction)()) {
        console.error(message);
    }
    else {
        throw new Error(message);
    }
}
exports.logError = logError;
